

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {

  1: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P65-E1',
    audio: 'img/FriendsPlus/Page64/Audio/audio-e2-p64.mp3',
    video: 'img/FriendsPlus/Page64/Videos/e2.p64.mp4',
    component: UI,
    recorder: true,
    titleQuestion: [{ num: '1', title: 'Listen to the story and repeat.Act. ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ', color: '#5196C7' }], // ㅤㅤㅤㅤㅤ đừng động vô khoảng trống này( kí tự đặc biệt đó)
    exerciseKey: 'img/FriendsPlus/Page64/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column2
        { url: 'img/FriendsPlus/Page64/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page64/Audio/hinh1-e2-p64.mp3' },
        { url: 'img/FriendsPlus/Page64/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page64/Audio/hinh2-e2-p64.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page64/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page64/Audio/hinh3-e2-p64.mp3' },
        { url: 'img/FriendsPlus/Page64/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page64/Audio/hinh4-e2-p64.mp3' },

      ],
    ],
  },

  2: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P65-E2',
    audio: 'img/FriendsPlus/Page65/Audio/audio-e2-p65.mp3',
    video: '',
    component: D1,
    recorder: true,
    exerciseKey: 'img/FriendsPlus/Page65/E2/Key/answerKey.png',
    questionImage: [ // Row      
      [
        // Column1
        { url: 'img/FriendsPlus/Page65/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page65/Audio/tieude-e2-p65.mp3' },
        { url: 'img/FriendsPlus/Page65/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page65/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page65/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page65/Audio/doan1.mp3' },
        { url: 'img/FriendsPlus/Page65/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page65/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/9.jpg', audioUrl: 'img/FriendsPlus/Page65/Audio/doan2.mp3' },
        { url: 'img/FriendsPlus/Page65/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page65/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/12.jpg', audioUrl: 'img/FriendsPlus/Page65/Audio/doan3.mp3' },
        { url: 'img/FriendsPlus/Page65/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page65/E2/14.jpg' },
      ],

    ],
  },
  3: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P65-E3',
    audio: '',
    video: '',
    component: D1,
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page65/E3/Key/answerKey.png',
    maxLength: 1,
    questionImage: [ // Row
      [
        // Column1 1 T 2 F 3 T 4 F 5 T 6 T
        { url: 'img/FriendsPlus/Page65/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page65/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/3.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page65/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page65/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/6.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page65/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page65/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/9.jpg', input: true, answer: "F" },
        { url: 'img/FriendsPlus/Page65/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page65/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/12.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page65/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page65/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/15.jpg', input: true, answer: "T" },
        { url: 'img/FriendsPlus/Page65/E3/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page65/E3/17.jpg' },
      ],

    ],
  },
  4: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P65-E4',
    audio: '',
    video: '',
    component: T6,
    exerciseKey: 'img/FriendsPlus/Page65/E4/Key/answerKey.png',
    inputSize: 130,
    titleQuestion: [{ num: '4', title: 'Write.' }],
    questionImage: [],
    questions: [
      {
        title:
          `
                <div style='display:flex'>
                    <div style='margin-right:30px'>
                        <div>  <b> 1 &nbsp</b> The U.S.A. is <u style='color:rgb(82,197,235)'> bigger </u>   (big) than Viet Nam.</div>
                        <div>  <b> 2 &nbsp</b> Mount Everest is the # (high) mountain  in the world.</div>
                        <div>  <b> 3 &nbsp</b> Cars are  # (fast) than bikes. </div>
                        <div>  <b> 4 &nbsp</b> Grapes are # (small) than apples.</div>
                        <div>  <b> 5 &nbsp</b> Lake Baikal is the # (deep) lake in the world.</div>
                        <div>  <b> 6 &nbsp</b> Mice are # (slow) than cheetahs.</div>
                    </div>
                    
                </div>
                
      `,
        answer: [
          "highest",
          "faster",
          "smaller",
          "deepest",
          "slower",
        ],
        // type: 'longAnwser'
      },
    ]
  },
  5: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P65-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    questionImage: [ // Row
      [
        // Column2
        { url: 'img/FriendsPlus/Page65/E5/1.jpg' },
      ]
    ],
  },


}
export default json;
